/**
 * useChartData - Hook for loading chart data with 3-tier caching
 */

import { useState, useEffect } from 'react';
import ChartDataLoader from '../utils/chartLoader.js';

export default function useChartData(ticker, period = '1y') {
  const [chartData, setChartData] = useState(null);
  const [historicalData, setHistoricalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!ticker) return;

    const loadData = async () => {
      try {
        setIsLoading(true);
        setError(null);

        // Load chart data (signals, strategies)
        const chart = await ChartDataLoader.loadChartData(ticker);
        setChartData(chart);

        // Load historical data (OHLCV + indicators)
        const history = await ChartDataLoader.loadHistoricalData(ticker, period);
        setHistoricalData(history);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, [ticker, period]);

  return {
    chartData,
    historicalData,
    isLoading,
    error
  };
}
